// extracted by mini-css-extract-plugin
export default {"drawer_body_class":"drawer_body_class","drawer_warning_icon":"drawer_warning_icon","drawer_selectStore_error":"drawer_selectStore_error"};